import { useCallback, useEffect, useState } from "react";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import { useSelector } from "react-redux";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import Select from "react-select";
import DropDownStyles from "./dropdownStyles.js";
import APIs from "../../Constants/apis.js";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast.js";
import FormInput from "../../components/CustomComponents/Input/formInput.jsx";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery.jsx";
import schedule from "../../components/CustomComponents/TimeSchedule/schedule.js";
import ScheduleManager from "../../components/CustomComponents/TimeSchedule/weeklySlots.js";
import CommonTimeSlotForAllWeek from "../../components/CustomComponents/TimeSchedule/commonTimeSlotForAllWeek.js";
import moment from "moment";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";


function AddStaff() {
  const navigate = useNavigate();
  const CompID = useSelector((state) => state.auth.user).userData?.compID;
  const [roles, setRoles] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [regularHours, setRegularHours] = useState(true);
  const [useSameTimeSlots, setUseSameTimeSlots] = useState(true);
  const [commonTimeSlot, setCommonTimeSlot] = useState([
    {
      from: "9:30 AM",
      to: "1:00 PM",
    },
  ]);

  const [schedules, setSchedules] = useState(schedule);

  const [staffData, setStaffData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    country: "UK",
    phoneNo: "",
    passCode: "",
    ratePerHour: 0,
    active: false,
    userRoles: null,
    isBreakAllowed: false,
    breakMinutes: null,
    password: "",
  });

  const FetchRoles = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_ROLES, {
        params: {
          CompID,
        },
      });
      const roleData = response.data.data || response.data;

      const rolesOptions = roleData.map((role) => ({
        value: role.comRolePermission_ID,
        label: role.r_Title,
      }));
      setRoles(rolesOptions);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, [CompID]);

  const FetchCountries = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_COUNTRIES);
      const roleData = response.data.data || response.data;

      const mappedOptions = roleData.map((country) => ({
        value: country.code,
        label: country.name,
      }));
      setCountries(mappedOptions);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  }, []);

  const applyCommonTimeSlotToAll = () => {
    const updatedSchedules = schedules.map((schedule) => ({
      ...schedule,
      timeSlots: commonTimeSlot.map((slot) => ({ ...slot })),
    }));
    setSchedules(updatedSchedules);
  };


  useEffect(() => {
    FetchRoles();
    FetchCountries();
  }, [FetchRoles, FetchCountries]);

  const HandleSubmit = async () => {
    const {
      userName,
      firstName,
      lastName,
      email,
      country,
      password,
      passCode,
      phoneNo,
      ratePerHour,
      active,
      isBreakAllowed,
      breakMinutes,
    } = staffData;

    if (
      !userName ||
      !firstName ||
      !lastName ||
      !email ||
      !country ||
      !password ||
      !passCode
    ) {
      alert("Please fill in all required fields.");
      return;
    }
    try {
      setLoading(true);

      const formattedSchedules = [];
      if (!regularHours) {
        if (useSameTimeSlots) {
          const days = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ];
          commonTimeSlot.forEach((slot) => {
            days.forEach((day) => {
              formattedSchedules.push({
                ID: 0,
                CompID: CompID,
                UserName: userName,
                DayName: day,
                OpenTime: moment(slot.from, ["h:mm A"]).format("hh:mm A"),
                CloseTime: moment(slot.to, ["h:mm A"]).format("hh:mm A"),
                UpdateDateTime: new Date().toISOString(),
              });
            });
          });
        } else {
          schedules.forEach((schedule) => {
            schedule.timeSlots.forEach((slot) => {
              if (moment(slot.from, ["h:mm A"]).isValid() && moment(slot.to, ["h:mm A"]).isValid()) {
                formattedSchedules.push({
                  ID: 0,
                  CompID: CompID,
                  UserName: userName,
                  DayName: schedule.day,
                  OpenTime: moment(slot.from, ["h:mm A"]).format("hh:mm A"),
                  CloseTime: moment(slot.to, ["h:mm A"]).format("hh:mm A"),
                  UpdateDateTime: new Date().toISOString(),
                });
              }
            });
          });
        }
      }

      await axiosInstance.post(APIs.ADD_STAFF, {
        UserName: userName,
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Country: country,
        PhoneNo: phoneNo,
        PassCode: passCode,
        RatePerHour: ratePerHour,
        Active: active,
        Password: password,
        CompID: CompID,
        ComRolePermission_ID: selectedRole.value,
        IsBreakAllowed: isBreakAllowed,
        BreakMinutes: breakMinutes,
      });
      setLoading(false);
      showSuccessToast("Staff added successfully!");
      navigate("/staff/manageStaff");
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        const errorMessage = error.response.data.message;
        if (
          errorMessage.includes("Passwords must be at least 6 characters") ||
          errorMessage.includes(
            "Passwords must have at least one non alphanumeric character"
          ) ||
          errorMessage.includes("Passwords must have at least one digit ('0'-'9')") ||
          errorMessage.includes(
            "Passwords must have at least one uppercase ('A'-'Z')"
          )
        ) {
          showErrorToast("Password does not meet the required criteria.");
        } else {
          showErrorToast(errorMessage);
        }
      } else {
        showErrorToast("Failed to add staff.");
      }
    }
  };

  return (
    <div>
      {loading && <Preloader />}
      <div className="d-flex align-items-center mb-2 mt-2">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/staff/manageStaff">Manage Staff</Link>
            </li>
            <li className="breadcrumb-item active">Add Staff</li>
          </ol>
          <h1 className="page-header mb-0">Add New Staff</h1>
        </div>
        <div className="ms-auto">
          <button
            onClick={() => HandleSubmit()}
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
            Submit
          </button>
        </div>
      </div>

      <Panel>
        <PanelHeader>General</PanelHeader>
        <PanelBody>
          <div className="row mb-3">
            <div className="col-6">
              <FormInput
                label="User Name"
                placeHolder="Enter User Name"
                type="text"
                value={staffData.userName}
                onchange={(e) =>
                  setStaffData({ ...staffData, userName: e.target.value })
                }
              />
            </div>
            <div className="col-6">
              <FormInput
                label="First Name"
                placeHolder="Enter First Name"
                type="text"
                value={staffData.firstName}
                onchange={(e) =>
                  setStaffData({ ...staffData, firstName: e.target.value })
                }
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <FormInput
                label="Last Name"
                placeHolder="Enter Last Name"
                type="text"
                value={staffData.lastName}
                onchange={(e) =>
                  setStaffData({ ...staffData, lastName: e.target.value })
                }
              />
            </div>
            <div className="col-6">
              <FormInput
                label="Email"
                placeHolder="Enter Email"
                type="email"
                value={staffData.email}
                onchange={(e) =>
                  setStaffData({ ...staffData, email: e.target.value })
                }
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <label>Country</label>
              <Select
                value={selectedCountry}
                onChange={(option) => {
                  setSelectedCountry(option);
                  setStaffData({ ...staffData, country: option.value });
                }}
                options={countries}
                styles={DropDownStyles}
              />
            </div>
            <div className="col-6">
              <label>User Roles</label>
              <Select
                value={selectedRole}
                onChange={(option) => {
                  setSelectedRole(option);
                  setStaffData({ ...staffData, userRoles: option.value });
                }}
                options={roles}
                styles={DropDownStyles}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <FormInput
                label="Phone Number"
                placeHolder="Enter Phone Number"
                type="text"
                value={staffData.phoneNo}
                onchange={(e) =>
                  setStaffData({ ...staffData, phoneNo: e.target.value })
                }
              />
            </div>
            <div className="col-6">
              <FormInput
                label="Pass Code"
                placeHolder="Enter Pass Code"
                type="text"
                value={staffData.passCode}
                onchange={(e) =>
                  setStaffData({ ...staffData, passCode: e.target.value })
                }
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <FormInput
                label="Rate Per Hour"
                placeHolder="Enter Rate Per Hour"
                type="text"
                value={staffData.ratePerHour}
                onchange={(e) =>
                  setStaffData({ ...staffData, ratePerHour: e.target.value })
                }
              />
            </div>
            <div className="col-6">
              <FormInput
                label="Password"
                placeHolder="Enter Password"
                type="password" // Use password type for security
                value={staffData.password}
                onchange={(e) =>
                  setStaffData({ ...staffData, password: e.target.value })
                }
              />
            </div>
          </div>

          <div className="mb-2">
            <ToggleSwitch
              isChecked={staffData.active}
              onToggle={(e) =>
                setStaffData({ ...staffData, active: e.target.checked })
              }
              label="Active"
              name="active"
            />
          </div>

          <div className="mt-4 mb-3">
            <ToggleSwitch
              isChecked={staffData.isBreakAllowed}
              onToggle={(e) =>
                setStaffData({
                  ...staffData,
                  isBreakAllowed: e.target.checked,
                  breakMinutes: e.target.checked ? staffData.breakMinutes : "",
                })
              }
              label="Break Time"
              name="breakTimeEnabled"
            />
          </div>

          {staffData.isBreakAllowed && (
            <div className="col-6">
              <FormInput
                label="Break Time (Minutes)"
                placeHolder="Enter Break Time"
                type="int"
                value={staffData.breakMinutes}
                onchange={(e) =>
                  setStaffData({
                    ...staffData,
                    breakMinutes: e.target.value,
                  })
                }
              />
            </div>
          )}

          <div className="col-8 mb-3 mt-3">
            <ToggleSwitch
              isChecked={regularHours}
              onToggle={() => setRegularHours(!regularHours)}
              label={"Official Business Hours"}
              disabled={false}
            />
          </div>
          {!regularHours && (
            <div className="row m-3">
              <div className="mb-3">
                <ToggleSwitch
                  isChecked={useSameTimeSlots}
                  onToggle={() => {
                    setUseSameTimeSlots(!useSameTimeSlots);
                    if (!useSameTimeSlots) {
                      applyCommonTimeSlotToAll();
                    }
                  }}
                  label={"Use same time slots for all days"}
                  disabled={false}
                />
              </div>
              {useSameTimeSlots ? (
                <CommonTimeSlotForAllWeek
                  setCommonTimeSlots={setCommonTimeSlot}
                  commonTimeSlots={commonTimeSlot}
                />
              ) : (
                <ScheduleManager
                  schedules={schedules}
                  setSchedules={setSchedules}
                />
              )}
            </div>
          )}

        </PanelBody>
      </Panel>
    </div>
  );
}

export default AddStaff;